import { createApi } from '@/api/modules/utils'

const baseUrl = '/account/sub'
const api = createApi(baseUrl)

// 子账号相关
export const subAccountApi = {
  list: api('list', 'get'),
  insert: api('insert', 'post'),
  updateStatus: api('update_status', 'post'),
  delete: api('delete', 'get'),
}